import React, { ReactNode } from 'react';
import Avatar from '../Avatar/Avatar';
import Text from '../Text';
import './WelcomeMessage.less';
import { SummeryType } from '../../types';

export type WelcomeMessageProps = {
  title?: ReactNode;
  text?: string;
  avatar?: string;
  avatarAlt?: string;
  size?: SummeryType;
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TStudentInfoList: React.FC<WelcomeMessageProps> = ({
  title,
  text,
  avatar,
  avatarAlt,
}) => {
  return (
    <div className="t-welcomeMessage">
      <div className="t-avatarWrapper">
        <Avatar size="xl" src={avatar}>
          {avatarAlt}
        </Avatar>
      </div>
      <div className="t-welcomeTextWrapper">
        <Text rows={2} level={1} bold paddingBottom={2}>
          {title}
        </Text>
        <Text rows={2} level={3}>
          {text}
        </Text>
      </div>
    </div>
  );
};

export default TStudentInfoList;
